const state = {
  loading: false,
};

const getters = {};

const actions = {
  setLoading({ commit }, payload) {
    commit('setLoading', payload);
  },
};

const mutations = {
  setLoading(state, isActive) {
    state.loading = isActive;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
